import { ReactComponent } from "./sort-fill.svg";

interface Props {
  fill?: string;
}

const SortFillIcon: React.FC<Props> = ({ ...rest }) => {
  return <ReactComponent {...rest} />;
};

export default SortFillIcon;
